import { Dumbbell, LayoutDashboard, ShieldCheck } from "lucide-react";
import { cn } from "@pushup/ui";

export type AdminPage = "dashboard" | "celebrities";

interface SidebarProps {
  page: AdminPage;
  onNavigate: (page: AdminPage) => void;
}

export function Sidebar({ page, onNavigate }: SidebarProps) {
  return (
    <div className="fixed inset-y-0 left-0 z-20 w-[200px] py-4">
      <div className="flex h-full flex-col px-3">
        <div className="mb-6 text-center">
          <a
            href="#"
            onClick={(event) => {
              event.preventDefault();
              onNavigate("dashboard");
            }}
            className="inline-block text-lg uppercase tracking-wide text-lb-icon"
          >
            Light Blue
          </a>
        </div>

        <nav className="flex-1 space-y-1 overflow-y-auto">
          <p className="nav-title-lb">Template</p>
          <button
            type="button"
            onClick={() => onNavigate("dashboard")}
            className={cn("nav-link-lb", page === "dashboard" && "active")}
          >
            <LayoutDashboard className="size-4 shrink-0" />
            <span>Dashboard</span>
          </button>
          <button
            type="button"
            onClick={() => onNavigate("celebrities")}
            className={cn("nav-link-lb", page === "celebrities" && "active")}
          >
            <Dumbbell className="size-4 shrink-0" />
            <span>Celebrities</span>
          </button>

          <p className="nav-title-lb">Status</p>
          <div className="px-3 text-xs text-foreground/50">
            <p className="flex items-center gap-2">
              <ShieldCheck className="size-3.5 text-lb-lime" />
              On-device only
            </p>
            <p className="mt-2">
              Pushup Tracker admin console for managing celebrity opponents, pacing and voice clips.
            </p>
          </div>
        </nav>

        <div className="px-3 text-[11px] text-foreground/40">
          © {new Date().getFullYear()} Pushup
        </div>
      </div>
    </div>
  );
}
